import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import './ControlButton.css'

const ControlButton = ({ showAllWrecks, setShowAllWrecks }) => {
  const map = useMap()

  const getInput = () => {
    const inputContainer = L.DomUtil.create('div', 'control-button-input-container')

    const input = L.DomUtil.create('input')
    input.type = 'checkbox'
    input.id = 'show-wrecks'
    input.checked = showAllWrecks

    input.onclick = () => {
      setShowAllWrecks((prev) => {
        window.sessionStorage.setItem('show_all_wrecks', !prev)
        return !prev
      })
    }

    const label = L.DomUtil.create('label', 'control-button-input-label')
    label.htmlFor = 'show-wrecks'
    label.innerText = 'Näytä kaikki hylyt'

    inputContainer.appendChild(input)
    inputContainer.appendChild(label)

    return inputContainer
  }

  useEffect(() => {
    const OverlayButton = L.Control.extend({
      onAdd: function () {
        const container = L.DomUtil.create('div', 'leaflet-bar control-button-container')
        const button = L.DomUtil.create('button', 'bi bi-gear fs-4 p-0 control-button-button')
        const input = getInput()

        container.appendChild(button)
        container.appendChild(input)
        input.hidden = true

        container.onmouseenter = () => {
          button.hidden = true
          input.hidden = false
        }
        container.onmouseleave = () => {
          input.hidden = true
          button.hidden = false
        }

        return container
      },
    })

    const customControl = new OverlayButton({ position: 'topleft' })
    customControl.addTo(map)

    return () => {
      map.removeControl(customControl)
    }
  }, [map])
  return null
}

export default ControlButton
